import {displayLocalValidationErrorPromise} from "../../../helpers/forms/validationErrors/utils";

class BaseStage {
    /** @var {AdminGlobalState} */
    globalState;
    /** @var {HTMLElement} */
    domContainer

    constructor(globalState) {
        this.globalState = globalState;
    }

    getStageKey() {
        // Each child should take care of retrieving and
        // initializing it's related dom container
        throw 'Attempting to retrieve undefined stage key'
    }

    display() {
        this.domContainer.classList.remove('d-none');

        if (this.totalPreviewComponent && this.totalPreviewComponent.hasStaleTotals()) {
            void this.totalPreviewComponent.updateTotalsFromServer();
        }
    };

    /**
     * Initializes all default components shared by all stages
     */
    initSharedComponents() {
        this.setupStageManagerButtons();
    }

    setupStageManagerButtons() {
        this.nextButton = this.domContainer.querySelector('button.next-stage-button');
        this.previousButton = this.domContainer.querySelector('button.previous-stage-button');

        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => {
                this.globalState.stageManager.nextStage();
            })

            // Disable next step by default
            this.disableNextStageButton()
        }

        if (this.previousButton) {
            this.previousButton.addEventListener('click', () => {
                this.globalState.stageManager.previousStage();
            })
        }

        // Keep previous button disabled whenever the current flow has no valid back stage.
        if (!this.globalState.stageManager.canGoToPreviousStage()) {
            this.disablePreviousStageButton();
            if (this.previousButton) {
                this.previousButton.classList.add('opacity-0-important');
            }
        } else {
            this.enablePreviousStageButton();
            if (this.previousButton) {
                this.previousButton.classList.remove('opacity-0-important');
            }
        }
    }

    enableNextStageButton() {
        this.nextButton.disabled = false;
    }

    disableNextStageButton() {
        this.nextButton.disabled = true;
    }

    enablePreviousStageButton() {
        if (!this.previousButton) {
            return;
        }
        this.previousButton.disabled = false;
    }

    disablePreviousStageButton() {
        if (!this.previousButton) {
            return;
        }
        this.previousButton.disabled = true;
    }

    clearDom() {
        // Each method clears its own DOM elements if required
    }

    /**
     * Handles special case errors, if true is returned then no more error handling should be done
     *
     * @param error
     * @return {boolean}
     */
    handleSpecialErrors(error) {
        if (!error.response || !error.response.data || !error.response.data.errors) {
            // Not expected format
            return false;
        }

        const validationErrors = error.response.data.errors

        // Seat key not found in group
        if (this.errorResponseContains(validationErrors, 'seat_key_not_found_in_group')) {
            // Let user now
            displayLocalValidationErrorPromise(document.body, 'dummy', 'Seat not found in group')
                .then(() => {
                    this.globalState.stageManager.goToStage('seat-select');
                })

            return true;
        }

        if (this.errorResponseContains(validationErrors, 'visitor_type_not_found')) {
            // Let user now
            displayLocalValidationErrorPromise(document.body, 'dummy', 'Visitor type not found for selected section')
                .then(() => {
                    this.globalState.stageManager.goToStage('seat-type-select');
                })

            return true;
        }

        // Did nothing, let default error handler taker over
        return false;
    }

    errorResponseContains(errors, keyOrErrorString) {
        // Check if key contains search
        for (const item of Object.keys(errors)) {
            if (item.includes(keyOrErrorString)) {
                return true;
            }
        }

        // Check if error text contains search
        for (const errorArray of Object.values(errors)) {
            for (const errorString of errorArray) {
                if (errorString.includes(keyOrErrorString)) {
                    return true;
                }
            }
        }

        return false;
    }
}

export {BaseStage};
